"use client";
import { Toaster } from "react-hot-toast";
export { Toaster };
